import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { ContactDetails, ContactDetailsForCreation, ContactDetailsForUpdate, eMatSelectAppearance } from 'reg-hub-common';
import { EnvironmentUrlService } from '../../services/environment-url/environment-url.service';

@Component({
    selector: 'app-client-contact-details-card',
    templateUrl: './client-contact-details-card.component.html',
    styleUrls: ['./client-contact-details-card.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClientContactDetailsCardComponent {
  @Input() enabled: boolean = true;
  @Input() contactDetails!: ContactDetails | ContactDetailsForCreation | ContactDetailsForUpdate;
  @Input() emailRequired: boolean = false;
  emailLabel: string = "Email";
  protected appearance: MatFormFieldAppearance = eMatSelectAppearance.outline;
  isEditing = false;

  constructor() { }

  ngOnInit(): void {
    if (this.emailRequired) {
      this.emailLabel = `*${this.emailLabel}`;
    }
  }

  protected handleJurisdictionChangeEvent(jurisdiction: string | string[]) {
    this.contactDetails.address.jurisdiction = jurisdiction as string;
  }

  protected handleCountryChangeEvent(country: string) {
    this.contactDetails.address.countryCode = country;
  }
}